import request from '@/services/index.jsx';
import { readPageResponse } from './pageResponse.js';

// Immutable runtime releases are managed separately from ordinary draft edits.
export const getAgentRuntime = agentId => request.get('/api/workflow/agent/runtime/get',{agentId},{silentError:true});
export const getProductBackgroundBindings = () => request.get('/api/workflow/agent/runtime/product-background-bindings',undefined,{silentError:true});
export const bindProductBackgroundAgents = command => request.post('/api/workflow/agent/runtime/product-background-bindings',command,{silentError:true});
export const getModelBackgroundBindings = () => request.get('/api/workflow/agent/runtime/model-background-bindings',undefined,{silentError:true});
export const bindModelBackgroundAgents = command => request.post('/api/workflow/agent/runtime/model-background-bindings',command,{silentError:true});
export const getAgentRuntimeRelease = (agentId,releaseId) => request.get('/api/workflow/agent/runtime/release',{agentId,releaseId},{silentError:true});
export const prepareAgentRuntime = (agentId,expectedRevision,settings,feature='change_color') => {
  if(!['change_color','poster_standard','poster_quality','image_fission','batch_matting','product_background_reference','product_background_no_reference','model_background_reference','model_background_no_reference','ai_model'].includes(feature))throw new Error('RUNTIME_FEATURE_INVALID');
  const product=['product_background_reference','product_background_no_reference'].includes(feature);
  const model=['model_background_reference','model_background_no_reference'].includes(feature);
  const path=model?'prepare-model-background':product?'prepare-product-background':feature==='change_color'?'prepare-change-color':feature==='image_fission'?'prepare-image-fission':feature==='batch_matting'?'prepare-batch-matting':feature==='ai_model'?'prepare-ai-model':'prepare-poster';
  const selection=product||model?`&withReference=${feature.endsWith('_background_reference')}`:['change_color','image_fission','batch_matting','ai_model'].includes(feature)?'':`&model=${feature==='poster_standard'?2:1}`;
  return request.post(`/api/workflow/agent/runtime/${path}?agentId=${encodeURIComponent(agentId)}&expectedRevision=${encodeURIComponent(expectedRevision)}${selection}`,settings,{silentError:true});
};
export const activateAgentRuntime = (agentId,releaseId,expectedRevision) => request.post('/api/workflow/agent/runtime/activate',
  {agentId,releaseId,expectedRevision,confirmed:true},{useParams:true,silentError:true});
export const getChangeColorBinding = () => request.get('/api/workflow/agent/runtime/binding',undefined,{silentError:true});
export const bindChangeColorAgent = (agentId,expectedRevision,expectedRuntimeRevision) => request.post('/api/workflow/agent/runtime/binding',
  {agentId,expectedRevision,expectedRuntimeRevision,confirmed:true},{useParams:true,silentError:true});
export const getAgentFeatureBinding = featureKey => request.get('/api/workflow/agent/runtime/binding',{featureKey},{silentError:true});
export const bindAgentFeature = (featureKey,agentId,expectedRevision,expectedRuntimeRevision) => request.post('/api/workflow/agent/runtime/binding',
  {featureKey,agentId,expectedRevision,expectedRuntimeRevision,confirmed:true},{useParams:true,silentError:true});

// 标签管理相关API
export const addLabel = (data) => {
  return request.post('/api/workflow/label/add', data);
};

export const updateLabel = (data) => {
  return request.post('/api/workflow/label/update', data);
};

export const deleteLabel = (labelId) => {
  return request.post('/api/workflow/label/delete', { labelId }, { useParams: true });
};

export const getLabels = () => {
  return request.get('/api/workflow/labels');
};

// 分类管理相关API
export const addClassification = (data) => {
  return request.post('/api/workflow/classification/add', data);
};

export const updateClassification = (data) => {
  return request.post('/api/workflow/classification/update', data);
};

export const deleteClassification = (classificationId) => {
  return request.post('/api/workflow/classification/delete', { classificationId }, { useParams: true });
};

export const getClassifications = () => {
  return request.get('/api/workflow/classifications');
};

// 工作流管理相关API
export const addWorkFlow = (data) => {
  return request.post('/api/workflow/add', data);
};

export const updateWorkFlow = (data) => {
  return request.post('/api/workflow/update', data);
};

export const deleteWorkFlow = (workFlowId) => {
  return request.post('/api/workflow/delete', { workFlowId }, { useParams: true });
};

export const getWorkFlow = (workFlowId, options = {}) => {
  return request.get('/api/workflow/get', { workFlowId }, options);
};

export const getWorkFlowList = async (params, options = {}) => {
  const { current, pageSize, title, ...otherParams } = params;
  const res = await request.get('/api/workflow/list', {
    pageNum: current,
    pageSize,
    title,
    ...otherParams
  }, options);
  return readPageResponse(res);
};

export const exportWorkFlow = (workFlowIds) => {
  return request.get('/api/workflow/export', { workFlowIds });
};

export const importWorkFlow = (file, status) => {
  const formData = new FormData();
  formData.append('file', file);
  if (status) {
    formData.append('status', status);
  }
  return request.post('/api/workflow/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 智能体管理相关API
export const addAgent = (data) => {
  return request.post('/api/workflow/agent/add', data, { silentError: true });
};

export const updateAgent = (data) => {
  return request.post('/api/workflow/agent/update', data, { silentError: true });
};

export const deleteAgent = (agentId, keepWorkflow = false) => {
  return request.post('/api/workflow/agent/delete', { agentId, keepWorkflow }, { 
    useParams: true
  });
};

export const getAgent = (agentId, options = {}) => {
  return request.get('/api/workflow/agent/get', { agentId }, options);
};

export const getAgentList = async (params, options = {}) => {
  const { current, pageSize, title, ...otherParams } = params;
  const res = await request.get('/api/workflow/agent/list', {
    pageNum: current,
    pageSize,
    title,
    ...otherParams
  }, options);
  return readPageResponse(res);
};

export const exportAgent = (agentIds) => {
  return request.get('/api/workflow/agent/export', { agentIds });
};

export const importAgent = (file, status) => {
  const formData = new FormData();
  formData.append('file', file);
  if (status) {
    formData.append('status', status);
  }
  return request.post('/api/workflow/agent/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getAgentExportTask = (requestId, options = {}) => request.get('/api/workflow/agent/export/get', { requestId }, options);
export const getAgentExportDownloadUrl = requestId => request.get('/api/workflow/agent/export/download', { requestId });
export const getAgentImportTask = (requestId, options = {}) => request.get('/api/workflow/agent/import/get', { requestId }, options);
export const getAgentExportHistory = (options = {}) => request.get('/api/workflow/agent/export/list', {}, options);
export const getAgentImportHistory = (options = {}) => request.get('/api/workflow/agent/import/list', {}, options);
export const previewAgentImport = (file, mappings = []) => {
  const body = new FormData();
  body.append('file', file);
  if (mappings.length) body.append('mappings', JSON.stringify(mappings));
  return request.post('/api/workflow/agent/import/preview', body, { headers: { 'Content-Type': 'multipart/form-data' }, silentError: true });
};
export const confirmAgentImport = (previewId, replaceOnline = false, confirmOwnership = false) => request.post('/api/workflow/agent/import/confirm', { previewId, replaceOnline, confirmOwnership });
export const getAgentImportIdentity = (mapping, options) => request.get('/api/workflow/agent/import/identity', {
  userId: mapping.userId, groupId: mapping.groupId, sharedGroups: mapping.sharedGroups,
}, options);

// 算力计算规则管理相关API
export const getComputeRuleList = async (params) => {
  const { current, pageSize, description, classType, orderBy, asc = false, ...otherParams } = params;
  const res = await request.get('/api/workflow/computeRule/list', {
    pageNum: current,
    pageSize,
    description,
    classType,
    orderBy,
    asc,
    ...otherParams
  });
  return {
    success: res.success,
    message: res.message,
    total: res.data?.total,
    data: res.data?.list || res.data?.records || []
  };
};

export const addComputeRule = (data) => {
  return request.post('/api/workflow/computeRule/add', data);
};

export const updateComputeRule = (data) => {
  // 注意：更新接口需要包含id字段，但不需要sign字段
  return request.post('/api/workflow/computeRule/update', data);
};

export const deleteComputeRule = (id) => {
  return request.post('/api/workflow/computeRule/delete', { id }, { useParams: true });
};

// 获取计算规则详情（如果需要的话）
export const getComputeRule = (id) => {
  return request.get('/api/workflow/computeRule/get', { id });
};

// 批量删除计算规则（如果需要的话）
export const batchDeleteComputeRule = (ids) => {
  return request.post('/api/workflow/computeRule/batchDelete', { ids });
};

// 批量操作工作流状态（如果需要的话）
export const batchUpdateWorkFlowStatus = (workFlowIds, status) => {
  return request.post('/api/workflow/batchUpdateStatus', { workFlowIds, status });
};

// 批量操作智能体状态（如果需要的话）
export const batchUpdateAgentStatus = (agentIds, status) => {
  return request.post('/api/workflow/agent/batchUpdateStatus', { agentIds, status });
};

// Configured read-only sources; preparation creates a preview and never confirms target writes.
export const getFeishuSources = (options = {}) => request.get('/api/workflow/feishu/sources', {}, options);
export const getFeishuTasks = (options = {}) => request.get('/api/workflow/feishu/tasks', {}, options);
export const getFeishuTask = (id, options = {}) => request.get('/api/workflow/feishu/task', { id }, options);
export const readFeishuSource = body => request.post('/api/workflow/feishu/read', body, { silentError: true });
export const prepareFeishuSource = body => request.post('/api/workflow/feishu/prepare', body, { silentError: true });

export const recheckFeishuSource = body => request.post('/api/workflow/feishu/recheck', body, { silentError: true });
